import React, {useEffect, useMemo, useState} from 'react'
import styled, {css} from "styled-components";
import {Button as AntdButton, Popover, Checkbox as AntdCheckbox, Radio, Grid} from 'antd'
import AllIcon from '../assets/images/icons/icon-all@2x.png'
import TriangleIcon from '../assets/images/icons/icon-triangle@2x.png'
import {useQuery} from "react-query";
import {getCompanyCategories} from "../api/User";

const {useBreakpoint} = Grid

const FiltersWrap = styled.div`
  ${({isMobile}) => isMobile ? css`
    padding-bottom: 10px;
    justify-content: flex-end;
    > button {
      padding: 12px 0;
      span {
        font-size: 12px;
      }
    }
    button + button {
      margin-left: 5px !important;
    }
  ` : css`
    position: absolute;
    right: 0;
    top: 0;
  `}
  display: flex;
  flex-wrap: wrap;
`

const Button = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6EE6C6;
  background-color: #0E0E0E;
  border: none;
  padding: 12px 23px;
  height: 35.5px;
  span {
    font-size: 14px;
    line-height: 1;
    margin: 11px;
  }
  & + & {
    margin-left: 10px;
  }
  &:hover,
  &:focus {
    color: #6EE6C6;
    background-color: #0E0E0E;
  }
  > img {
    transition: transform 300ms;
  }
  &.ant-popover-open > img {
    transform: rotate(-180deg);
  }
`

const RadioButton = styled(Radio.Button)`
  border: none !important;
  padding: 0;
  &:focus-within {
    box-shadow: none !important;
  }
`

const Checkbox = styled(AntdCheckbox)`
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #6EE6C6;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #6EE6C6;
    border-color: #6EE6C6;
    &::after {
      border-color: #1f1f1f;
    }
  }
`

const PopoverContent = styled.div`
  min-width: 130px;
`

export const Filters = ({onChange, sortByList}) => {
   const {data} = useQuery('companyCategory', getCompanyCategories, {
     refetchOnWindowFocus: false
   })
  const [categories, setCategories] = useState([])
  const [sortBy, setSortBy] = useState()
  const breakpoint = useBreakpoint();

  const isMobile = useMemo(() => {
    return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
  }, [breakpoint])

  const reset = () => {
    setCategories([])
    setSortBy(undefined)
  }

  useEffect(() => {
    onChange({
      sortBy,
      categories
    })
  }, [sortBy, categories])

  return (
    <FiltersWrap isMobile={isMobile}>
      <Button onClick={reset}>
        <img width={12} src={AllIcon} alt=""/>
        All
      </Button>
      <Popover content={(
        <Checkbox.Group value={categories} onChange={(checkedValue) => setCategories(checkedValue)}>
          {data?.data?.map(category => (
            <div key={category.id}>
              <Checkbox key={category.id} value={category.id}>{category.name}</Checkbox>
            </div>
          ))}
        </Checkbox.Group>
      )} placement='bottom' trigger="click">
        <Button>
          Project Type
            {
                categories.length ? ` (${categories.length})` : null
            }
          <img width={9} src={TriangleIcon} alt=""/>
        </Button>
      </Popover>
      <Popover content={(
          <PopoverContent>
              <Radio.Group value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                  {sortByList.map(sortBy => (
                      <div key={sortBy.id}>
                          <RadioButton key={sortBy.id} value={sortBy.id}>
                              {/* <span style={{
                    fontFamily: 'SourceHanSansCN-Regular',
                    }}>{sortBy.label}</span> */}
                              {sortBy.label}
                          </RadioButton>
                      </div>
                  ))}
              </Radio.Group>
          </PopoverContent>
      )} placement='bottom' trigger="click">
        <Button>
            {
                sortBy ? sortByList.find(item => item.id === sortBy).label : 'Sort by'
            }
          <img width={9} src={TriangleIcon} alt=""/>
        </Button>
      </Popover>
    </FiltersWrap>
  )
}
